<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goback()"></span>
    </div>
    
    <div class="title">请确认订单详情</div>

    <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'>

      <div class="weui-cells__title">服务详情，点击可修改</div>
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>服务类型</p>
            </div>
            <div class="weui-cell__ft">{{order.data.service_txt}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础费用</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.price>0">{{order.data.price | numeral('$0,0.00')}}</div>
            <div class="weui-cell__ft" v-else>现场评估</div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/misc-step2')">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft">{{order.data.service_date | moment("YYYY年M月D日")}} {{service_period}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/misc-step1')">
            <div class="weui-cell__bd">
                <p>服务地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.address_street}}, {{order.data.address_suburb}}, {{order.data.address_state}}, {{order.data.address_postcode}}<br>{{toTextFloor(order.data.floor)}} {{toTextParking(order.data.parking)}}</div>
        </a>

      </div>

      <div class="weui-cells__title">优惠券</div>
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/coupon-apply')">
            <div class="weui-cell__bd">
                <p>优惠券</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.coupon_id">{{order.data.coupon_title}}</div>
            <div class="weui-cell__ft" v-else>点击选择</div>
        </a>
      </div>

      
      <div class="weui-cells__title">服务需求</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <textarea class="weui-textarea" placeholder="可以详细描述一下您的情况需求，方便我们进一步沟通联系（选填）" rows="2"  v-model="order.data.msg"></textarea>
              </div>
          </div>
      </div>

      <div class="weui-cells__title">中介推荐码</div>
      <div class="weui-cells">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <input class="weui-input" type="text" placeholder="如果由中介推荐，请输入中介推荐码" v-model="order.data.agency">
              </div>
          </div>
      </div>

      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="isSubmiting=true">创建订单</div>
        </div>
      </div>
      <div class="js_dialog" v-show="isSubmiting">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">温馨提醒</strong></div>
              <div class="weui-dialog__bd">请确保服务信息无误，提交后信息将被锁定，只能联系客服修改</div>
              <div class="weui-dialog__ft">
                  <div  class="weui-dialog__btn weui-dialog__btn_default" @click="isSubmiting=false">关闭</div>
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="submitOrder()">确定提交</div>
              </div>
          </div>
      </div>


      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在提交</p>
              </div>
          </div>
      </transition>
      <img :src="pixelURL('clean','xiadan')" class="hide">
    </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'finalStep',
  data () {
    return {
      order:{},
      isSending:false,
      isSubmiting:false,
      pricing:{},
    }
  },
  methods: {
    editData(url){
      localStorage.isEditing = '/misc-step3';
      this.$router.push(url);
    },
    goback(){
      if(this.$route.query.src == 'order'){
        this.$router.push('/order');
      }
      else{
        this.$router.push('/misc-step2');
      }
    },

    submitOrder(){
      this.isSubmiting = false;
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        this.orderUpdate('msg',this.order.data.msg)

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
            orderObject.member_name = localStorage.member_name;
            orderObject.member_phone = localStorage.member_phone;
            orderObject.member_mail = localStorage.member_mail;
        }
        else{
            orderObject.token = 0;
            orderObject.member_name = orderObject.address_name;
            orderObject.member_phone = orderObject.address_phone;
        }

        orderObject.service_date = new Date(orderObject.service_date);
        orderObject.service_date = Vue.filter('moment')(orderObject.service_date,"YYYY-MM-DD");
        
        orderObject['order_source'] = '3';


        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Order/createOrder', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            localStorage.removeItem('order');

            that.$router.push('/order-prepay?id='+response.data.data.order_number+'&status=0&amount='+that.depositAmount());
            if(response.data.data.accoun_status>=0){
              localStorage.account_status = response.data.data.accoun_status;
            }
            if(response.data.data.accoun_status == 2){
              localStorage.token = response.data.data.token;
              localStorage.member_phone = response.data.data.phone;
              localStorage.member_name = response.data.data.name;
              localStorage.tempPasswd = response.data.data.password;
            }
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },


    toTextParking(theVar){
      let result = '';
      switch (theVar) {
        case "1551410087":
          result = '有停车位'
          break;
        case "1551410093":
          result = '无停车位'
          break;
        default:
      }
      return result;
    },
    toTextFloor(theVar){
      let result = '';
      switch (theVar) {
        case "1551412462":
          result = '有电梯/住G层'
          break;
        case "1551412475":
          result = '1层 无电梯'
          break;
        case "1551412486":
          result = '2层 无电梯'
          break;
        case "1551412499":
          result = '3层 无电梯'
          break;
        case "1551412509":
          result = '4层 无电梯'
          break;
        case "1551412525":
          result = '5层 无电梯'
          break;
        case "1551412535":
          result = '5层以上 无电梯'
          break;
        default:
      }
      return result;
    },
  },
  components: {
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.order.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
      }
      return result;
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "misc"){
        this.order = localParsed;
        this.userCatch(this.order.data.type_id,this.order.data.address_name,this.order.data.address_phone,true);
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell__ft{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:70%;
  font-size:0.9em;
}

.mini-title{
  margin-top:20px;
  color: #595D68;
  font-size: 12pt;
  text-align: center;
  font-weight: bold;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.prepay-img{
  width:100%;
}

.container /deep/{

  .couponPd{
    padding-top:0;
    padding-bottom:0;
  }

  .weui-vcode-btn{
    padding-right:0;
    margin-left:10px;
    color:#ff7444;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/misc/step3.vue